// jshint module: true

// Enable IE transitions-on-load prevention
const element = document.documentElement;

element.classList.add('is-loading');

window.addEventListener('load', () => window.requestAnimationFrame(() => element.classList.remove('is-loading')));



// WEBPACK FOOTER //
// ./bluemountain/assets/scripts/vendor/fabrique/polyfills/prevent-ie-transitions-on-load.js